<template>
  <section class="notes">
    <div v-for="note in notes">
      <Note :note="note" :key="note.id" />
    </div>
  </section>
</template>

<script>
  export default {
    props: ['notes']
  }
</script>

<style scoped>
  .notes {
    background: 'whitesmoke';
    padding: 0 2rem;
  }
</style>
